// initial state
const state = () => ({
    requests: 0,
    messages: [],
    messagesRead: []
});

// getters
const getters = {
    getRequestsState(state) {
        return state.requests;
    },
    getMessagesState(state) {
        return state.messages;
    },
    getMessagesReadState(state) {
        return state.messagesRead;
    },
};

// actions
const actions = {};

// mutations
const mutations = {
    setRequestsStateChanged(state) {
        state.requests++;
    },
    setNewMessageReceived(state, payload) {
        state.messages = payload;
    },
    setNewMessageRead(state, payload) {
        state.messagesRead = payload;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
